import styled from "styled-components";

export const AlarmEventManagementWrapper = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    height: 100%;
    position: relative;
    overflow-y: auto;
`;

export const AlarmEventOverviewWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    width: 100%;
    height: 70px;
`;

export const ToolBarWrapper = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px ; 
    padding: 14px 12px 0px 12px;
`;

export const FilterBar = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
    padding: 10px 2px 0px 0px; //
    height: 20px;

    & .query-button .ant-btn-disabled {
        background-color: #999999 !important;
        color: #EEEEEE;
    }

    & .query-button .ant-btn-disabled:hover {
        background-color: #999999 !important;
        color: #EEEEEE;
    }

    .query-button .anticon {
        font-size: 14px;
    }
`;

export const FilterItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;

    & .ant-select-selector {
        overflow: hidden;
    }

    & .ant-select-selection-overflow {
        flex-wrap: nowrap;
    }
`;

export const ButtonItem = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-left: auto;
`;

export const AlarmEventCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-auto-rows: min-content;
  align-items: start;
  gap: 16px;
  padding: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
    padding: 12px;
  }

  @media (min-width: 1200px) {
    grid-template-columns : repeat(auto-fill, minmax(320px, 1fr));
  }
`;

export const AlarmEventCardWrapper = styled.div`
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 14px 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: auto;
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
    border-color: #d0d0d0;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
`;

export const Name = styled.div`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  line-height: 1.4;
  flex: 1;
  padding-right: 8px;
`;

export const InfoLabel = styled.div`
  font-size: 12px;
  color: #8c8c8c;
  font-weight: 400;
  line-height: 1.2;
`;

export const InfoValue = styled.div`
  font-size: 14px;
  color: #333;
  font-weight: 500;
  line-height: 1.2;
  margin-bottom: 4px;
  
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const LastLine =  styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const ViewDetailButton = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #0f3363;
  border-bottom: 1px dashed #0f3363;
  line-height: 1.2; 
  padding-bottom: 2px; 
  width: 90px;
  margin-left: auto;
`;

export const PaginationWrapper = styled.div`
    justify-content: center;
    padding: 16px ;
    border-top: 1px solid #f0f0f0;
    background: #fff;
    
    .ant-pagination {
        margin: 0;
    }
`;